import React, { FC } from 'react';
import cx from 'classnames';

import styles from './TemplateOption.module.scss';
import { CloseDark } from 'esa-ui-library';
import { PropertyType } from '../../../../common';

interface TemplateOptionProps {
	template: PropertyType;
	isActive: boolean;
	onSelectTemplate: (t: PropertyType) => void;
	onDelete: (t: PropertyType) => void;
}

const TemplateOption: FC<TemplateOptionProps> = ({ template, isActive, onSelectTemplate, onDelete }): JSX.Element => {
	return (
		<li className={cx(styles.TemplateItem, { [styles.Active]: isActive })} onClick={() => onSelectTemplate(template)}>
			<div className={styles.Name}>
				<div>{template.label}</div>
				<div
					className={styles.Close}
					onClick={(e) => {
						e.stopPropagation();
					}}
				>
					<CloseDark size={16} onClick={() => onDelete(template)} />
				</div>
			</div>
		</li>
	);
};

export { TemplateOption };
